<template>
  <div class="keyset-page">
    <KeySet :column="column" :button="button" :LanguageSet="1" :api="'fieldsConfig'" :comDataId="dataId"
      @handleClickHandle="handleClickHandle" />
    <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" append-to-body :fullscreen="true">
      <languageSet v-if="title === '语言设置'" :dataIdFour="tableDataId" :typeFour="tableDataType"></languageSet>
      <codingSet v-if="title === '编码设置'" :codingSetData="codingSetData"></codingSet>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  align,
  filterType,
  dataType,
  datePrecisionType,
} from "@/assets/js/table";
import { findRoleList } from "@/api/sysTem/roleAdmin";
import { dictFind } from "@/api/dict";
import KeySet from "../com/index";
import { getSession } from "@/utils/methods";
import languageSet from '../LanguageSet/index.vue'
import codingSet from '../codingSet/index.vue'
export default {
  name: "keyset-page",
  extends: { KeySet },
  props: {
    dataIdOne: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      column: [
        { prop: "showOrder", label: this.$t('listOfSet.fieldShowOrder'), fixed: true,alignType: 2 },
        { prop: "fieldName", label: this.$t('listOfSet.databaseFieldName'), isReadOnly: true, fixed: true,alignType: 2 },
        { prop: "showName", label: this.$t('listOfSet.showName'), fixed: true,alignType: 2 },
        { prop: 'expressionDecimalDigit', label: this.$t('FormOfSet.expressionDecimalDigit'), alignType: 2 },
        { prop: 'colWidth', label: this.$t('listOfSet.colWidth') ,alignType: 2},
        { prop: "dataType", label: this.$t('listOfSet.dataType'), isReadOnly: false, list: dataType(), alignType: 2, type: "select" },
        { prop: "alignType", label: this.$t('listOfSet.alignType'), type: "select", list: align(),alignType: 2 },
        { prop: "filterType", label: this.$t('listOfSet.queryOperator'), type: "select", list: filterType(), alignType: 2 },
        { prop: "isFilter", label: this.$t('listOfSet.isSelect'), type: "switch",alignType: 2 },
        { prop: "isLocked", label: this.$t('listOfSet.isLocked'), type: "switch" ,alignType: 2},
        { prop: "isQueryKey", label:this.$t('listOfSet.isGlobalQuery'), type: "switch" ,alignType: 2},
        { prop: "isSum", label: this.$t('listOfSet.isSum'), type: "switch",alignType: 2 },
        { prop: "showForRoles", label: this.$t('listOfSet.isShow'), type: "select", multiple: true, collapseTags: true,
          optionLabel: "roleName", optionValue: "roleId", valueKey: "roleId",
          list: () => findRoleList().then((res) => res.result.map((item) => ({ ...item, roleId: item.id, }))) },
        { prop: "dicId", label: this.$t('listOfSet.dataDict'), type: "select", filterable: true, alignType: 2,
          list: () => { return dictFind().then((res) => res.map((item) => ({ value: item.id, label: item.dicName, })))} },
        { prop: "datePrecision", label: this.$t('listOfSet.datePrecision'), type: "select", list: datePrecisionType(), alignType: 2 },
      ],
      button: [],
      dataId: '',
      dialogVisible: false,
      title: '',
      tableDataId: '',
      tableDataType: '',
      codingSetData: {},
    };
  },
  components: { KeySet, languageSet, codingSet },
  watch: {
    dataIdOne: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    }
  },
  created() {
    // 语言
    // this.getLanguage();
  },
  methods: {
    handleClickHandle(title, row, LanguageSet) {
      switch (title) {
        case "Language":
          this.title = '语言设置'
          this.dialogVisible = true
          this.tableDataId = row.id
          this.tableDataType = LanguageSet
          break;
        case 'coding':
          this.title = '编码设置'
          this.dialogVisible = true
          this.codingSetData = row
          break;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.keyset-page {
  height: 100%;
}
</style>
